import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {of, Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {ApiService} from './api.service';
import {AppStateService} from './app-state.service';
import {AuthService} from './auth.service';
import {NavigationService} from './navigation.service';

@Injectable()
export class AuthGuard implements CanActivate {

  private authSourceUsed = false;
  private signerTokenUsed = false;

  constructor(private Auth: AuthService,
              private AppState: AppStateService,
              private Api: ApiService,
              private Router: Router,
              private Navigation: NavigationService) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const search = next.queryParams || {};
    const authSourceUrl = search['authSourceUrl'];
    if (authSourceUrl && !this.authSourceUsed) {
      this.Auth.setAuthSourceUrl(authSourceUrl);
      this.authSourceUsed = true;
    }
    const signerToken = search['signerToken'];
    if ((!this.Auth.hasAuthentication() || this.Auth.getAuthType() === 'timecard') // Override existing signer token
      && signerToken && !this.signerTokenUsed) {
      this.Auth.storeTimecardSignerToken(signerToken);
      this.signerTokenUsed = true;
    }
    if (search['minimal']) {
      this.AppState.minimal$.next(true);
    }

    if (!this.Auth.isFullyAuthenticated()) {
      this.AppState.loading$.next(true);

      return this.Api.refreshUser()
        .pipe(
          map(() => true),
          catchError(err => {
            if (this.Auth.hasAuthentication()) {
              // Authentication failed, but it wasn't a 401
              this.Navigation.handleError(err);
              return of(false);
            }
            return of(true);
          })
        );
    }

    return of(true);
  }
}
